import { render } from "./pot-individual-salary.vue?vue&type=template&id=b05e6420"
import script from "./pot-individual-salary.vue?vue&type=script&lang=js"
export * from "./pot-individual-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/pot/pot-individual-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b05e6420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b05e6420', __exports__)) {
    api.reload('b05e6420', __exports__)
  }
  
  module.hot.accept("./pot-individual-salary.vue?vue&type=template&id=b05e6420", () => {
    api.rerender('b05e6420', render)
  })

}


export default __exports__